export const API_STATUS_REQUEST = "API_STATUS_REQUEST";
export const API_STATUS_FAILURE = "API_STATUS_FAILURE";
export const API_STATUS_SUCCESS = "API_STATUS_SUCCESS";